import { getConfiguredPublicSiteUrl, normalizePublicSiteUrl } from './storefrontPublicUrl';

export const STOREFRONT_BRAND = {
  name: 'Temizlik Store',
  email: 'info@temizlikstore.com',
  website: 'https://temizlikstore.com',
  websiteDisplay: 'temizlikstore.com'
};

export const getStorefrontImageUrl = (imagePath) => {
  if (!imagePath) return '';
  const pathValue = typeof imagePath === 'object' && imagePath?.url ? imagePath.url : imagePath;
  if (!pathValue) return '';
  if (String(pathValue).startsWith('http')) return pathValue;
  const base = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/api\/?$/, '');
  return base + (String(pathValue).startsWith('/') ? pathValue : `/${pathValue}`);
};

export const getStorefrontHomeUrl = (companyCode) => {
  if (process.env.REACT_APP_PUBLIC_SITE === 'true') {
    return '/';
  }
  const code = String(companyCode || '').trim();
  return code ? `/store/${code}` : '/';
};

export const getStorefrontBrandName = (t, company) =>
  company?.name || t?.('storefront.title') || STOREFRONT_BRAND.name;

export const getStorefrontLogoUrl = (company) => {
  const logoUrl = company?.logo?.url;
  return logoUrl ? getStorefrontImageUrl(logoUrl) : '';
};

export const getStorefrontFaviconUrl = (storefrontSettings, company) => {
  const faviconPath = storefrontSettings?.favicon;
  if (faviconPath) {
    return getStorefrontImageUrl(faviconPath);
  }
  const logoUrl = company?.logo?.url;
  return logoUrl ? getStorefrontImageUrl(logoUrl) : '';
};

export const formatLocalPhone = (phone) => {
  const digits = String(phone || '').replace(/\D/g, '');
  if (digits.length === 12 && digits.startsWith('90')) {
    const local = digits.slice(2);
    return `0${local.slice(0, 3)} ${local.slice(3, 6)} ${local.slice(6, 8)} ${local.slice(8)}`;
  }
  if (digits.length === 11 && digits.startsWith('0')) {
    return `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7, 9)} ${digits.slice(9)}`;
  }
  if (digits.length === 10) {
    return `0${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 8)} ${digits.slice(8)}`;
  }
  return digits || String(phone || '').trim();
};

export const getPublicSiteUrl = (storefrontSettings, company) => {
  const configured = getConfiguredPublicSiteUrl(storefrontSettings);
  if (configured) return configured;

  const contactWebsite = String(company?.contact?.website || '').trim();
  if (contactWebsite) {
    const normalized = normalizePublicSiteUrl(contactWebsite);
    if (normalized) return normalized;
  }

  return STOREFRONT_BRAND.website;
};

export const getPublicSiteDisplay = (storefrontSettings, company) =>
  getPublicSiteUrl(storefrontSettings, company).replace(/^https?:\/\/(www\.)?/i, '');

export const getStorefrontContact = (company, storefrontSettings) => {
  const isPublicStore = process.env.REACT_APP_PUBLIC_SITE === 'true';
  const website = getPublicSiteUrl(storefrontSettings, company);
  const websiteDisplay = getPublicSiteDisplay(storefrontSettings, company);

  if (isPublicStore) {
    return {
      phone: company?.contact?.phone || '',
      email: company?.contact?.email || STOREFRONT_BRAND.email,
      website,
      websiteDisplay
    };
  }

  return {
    phone: company?.contact?.phone || '',
    email: company?.contact?.email || STOREFRONT_BRAND.email,
    website,
    websiteDisplay
  };
};
